import { render } from "./Events.vue?vue&type=template&id=30b2d899&scoped=true"
import script from "./Events.vue?vue&type=script&lang=js"
export * from "./Events.vue?vue&type=script&lang=js"

import "./Events.vue?vue&type=style&index=0&id=30b2d899&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-30b2d899"

export default script